import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { GuardShared } from './guard.shared.abstract';

@Injectable()
export class AuthGuard extends GuardShared {
  protected checkGuard(previousPage?: string, _route?: ActivatedRouteSnapshot): boolean {
    return this.sharedCheckGuard(previousPage);
  }

  protected getExceptionPages(): string[] {
    return [];
  }
}
